<template>
  <v-row no-gutters class="fill-height">
    <!-- <v-breadcrumbs
      class="ml-n5"
      :items="breadcrumbs"
      divider="/"
    ></v-breadcrumbs> -->
    <v-col class="px-6 pt-2 pb-12 fill-height">
      <h1 class="display-1">
        {{ $t("users") }}
        <span>
          {{ personnelLength }} {{ $t("total") }}</span>
      </h1>
      <h2 class="subtitle-2">{{ $t("personnelSubtitle") }}</h2>
      <div class="pt-5 pb-5 d-flex align-end justify-space-between">
        <v-col class="pb-0" cols="5">
          <v-text-field v-model="model.search" append-icon="mdi-magnify" :label="searchLabel" single-line clearable
            hide-details />
        </v-col>
        <!-- <div
          class="pb-0"
          cols="4">
          <v-btn 
            color="#e4e4e9"
            class="primary--text"
            rounded
             @click="selectPersonnel"
            >
              {{ $t("personnelAdd") }}
            </v-btn>
        </div> -->
      </div>
      <v-sheet>
        <v-data-table :headers="tableheaders" :items="personnel" :search="model.search" v-model="model.selected"
          fixed-header max-height="550px" item-key="tag" class="installation-table max-height elevation-1" :loading="isLoadingTable" :loading-text="$t('loadingData')">
          <template v-slot:[`item.emailVerified`]="{ item }">
            <v-icon v-if="item.emailVerified" color="success">
              mdi-checkbox-outline
            </v-icon>
          </template>
          <template v-slot:no-data>
            {{ $t("personnelEmpty") }}
          </template>
          <!-- does not use deviceInfo, but it needs to be attached to a value in devices, loggedIn is already used -->
          <!-- <template v-slot:[`item.id`] ="{item}">
          <Dropdown>
            <DropdownItem
              title="view"
              @clicked="selectPersonnel(item)"/>
            <DropdownItem
              title="edit"
              @clicked="editPersonnel(item)"/>
            <DropdownItem
              title="delete"
              @clicked="deletePersonnel(item)"/>
          </Dropdown>
        </template> -->
        </v-data-table>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { commonModule, companyModule } from '@/store/modules/store-accessor'
import Dropdown from '../components/dropdown/Dropdown.vue'
import DropdownItem from '../components/dropdown/DropdownItem.vue'
import FilterDropdown from '../components/dropdown/filter/FilterDropdown.vue'

@Component({
  components: { Dropdown, DropdownItem, FilterDropdown }
})
export default class Users extends Vue {
  tableheaders: any [] = [
    { text: this.$t("firstname"), sortable: true, class: 'row-style', value: 'firstName' },
    { text: this.$t("lastname"), sortable: true, class: 'row-style', value: 'lastName' },
    { text: this.$t("email"), sortable: true, class: 'row-style', value: 'email' },
    { text: this.$t("username"), sortable: true, class: 'row-style', value: 'username' },
    { text: this.$t("verified"), sortable: true, class: 'row-style', value: 'emailVerified' },
    { text: this.$t("created"), sortable: true, class: 'row-style', value: 'created_at' },
  ]

  model: any = {
    search: '',
    selected: [] as string[]
  }

  get personnelLength() {
    return companyModule.personnel.length
  }

  get searchLabel() {
    return this.$t("personnelSearch")
  }

  get personnel(){
    return companyModule.personnel
  }

  async mounted () {
    companyModule.getCompanyInfo();
    companyModule.getCompanyPersonnel();
    commonModule.initSnackbar({});
  }

  get isLoadingTable() {
    return companyModule.isLoadingTable;
  }
}
</script>

<style scoped lang="scss">

.installation-table:not(thead) {
  cursor: pointer;
  min-width: 600px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}


.max-height {
  max-height: 65vh;
  overflow: auto;
}

.placeholder {
  background-color: grey
}

h1 {
  margin-top: 40px;
  font-size: 35px;
  font-weight: 500;
  line-height: 65px;
}

span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 400;
  color: $pale-purple;
}
</style>
